import { IxGridNavigation } from './components/IxGridNav.js';

window.customElements.define('ix-grid-nav', IxGridNavigation);
